
import { http } from './config'

class NfeService {
    gerar(data){
        return http.post(`/v1/nfe/gerar`, data)
    }

    imprimir(venda_id){
        return http.post(`/v1/nfe/imprimir/${venda_id}`)
    }

    exportarXml(data) {
        return http.post(`/v1/nfe/xml/exportar?periodo_inicial=${data.periodo_inicial}&periodo_final=${data.periodo_final}`, data)
    }
    
    relatorio(data) {
        return http.get(`v1/nfe/relatorio?periodo_inicial=${data.periodo_inicial}&periodo_final=${data.periodo_final}`);
    }

    cancelar(data){
        return http.post('v1/nfe/cancelar', data)
    }

    enviarEmail(data){
        return http.post(`v1/nfe/enviar/email`, data)
    }

    estornar(data){
        return http.post(`v1/nfe/estornar`, data)
    }

    gerarCartaCorrecao(data){
        return http.post(`v1/nfe/carta-correcao/gerar`, data);
    }

    imprimirCartaCorrecao(data){
        return http.get(`v1/nfe/carta-correcao/imprimir/${data.venda_id}/${data.carta_correcao_id}`);
    }
    
}

export default new NfeService